import { ROUTES } from '@constants/constants';
import { Locale } from '@type-declarations/locale';
import { NavigationItem } from '@type-declarations/navigationItem';

export default function isSolutionsMainMenuItem(
  item: NavigationItem,
  locale: Locale,
): boolean {
  return item.title.toLowerCase() === ROUTES.SolutionsOverviewPage[locale];
}
